import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";

import LookWizardSectionGroup from "./lookWizardSectionGroup";
import {
  displayMaterialsWizardGroupAsFeature,
  getFeatureGroupFromWizardGroup
} from "./lookWizardFunctions";
import LookWizardSectionList from "./lookWizardSectionList";
import PropTypes from "prop-types";
import LookWizardSectionFilters from "./lookWizardSectionFilters";


const LookWizardSection = (props) => {

  const {wizardActiveItem, wizardStep, contentHeight, currentGroups} = props;

  if (!wizardActiveItem) {
    return null
  }

  if (!currentGroups.length) {
    return null
  }

  if (displayMaterialsWizardGroupAsFeature(currentGroups)) {
    return currentGroups.map(currentGroup => {
      const featureGroup = getFeatureGroupFromWizardGroup(currentGroup);
      return <LookWizardSectionGroup key={currentGroup.id} wizardGroup={currentGroup} featureGroup={featureGroup}/>
    })
  }

  if (currentGroups[0].nodeType === "filter") {
    return <LookWizardSectionFilters wizardGroup={currentGroups[0]}/>
  }

  // console.log("currentGroups", currentGroups);

  return <LookWizardSectionList wizardGroup={currentGroups[0]} wizardStepIndex={wizardStep.stepIndex} contentHeight={contentHeight}/>
};

LookWizardSection.propsTypes = {
  wizardStep: PropTypes.object.isRequired,
  contentHeight: PropTypes.number,
  currentGroups: PropTypes.array.isRequired,
}

const mapStateToProps = (store) => {
  const {wizardActiveItem, wizardActiveStep} = store.wizardState;
  return {
    wizardActiveItem,
    wizardActiveStep,
  };
};

const mapDispatchToProps = {
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookWizardSection)
)
